import React from 'react';
import PropTypes from 'prop-types';
import {Col} from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import api from "../../../../../util/clipstore/user/api";
import assets from "../../../../../util/assets";
import HomeCardComponent from "../card";
import {getEncryptedIdForBroadcaster} from "../../../../../util/broadcast_util";

HomeListContainer.propTypes = {
    totalItems: PropTypes.number.isRequired,
    loadNextPage: PropTypes.func.isRequired,
    hasMore: PropTypes.bool.isRequired,
    contentList: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
    openVideoPage: PropTypes.func.isRequired,
    openGalleryPage: PropTypes.func.isRequired,
};

function HomeListContainer(props) {

    return (
        <Col sm="12" className="bg-white p-3 mb-3 rounded">
            <InfiniteScroll
                dataLength={props.contentList.length}
                next={props.loadNextPage}
                hasMore={props.hasMore}
                loader={<div
                    className="display-flex-justify-content-flex-start-align-items-center">
                    <img
                        src={assets.loading_blue} alt="loading..." width={30}/>
                </div>}
                endMessage={<span/>}
            >

                {
                    props.contentList.map((content, index) => {
                        return (
                            <HomeCardComponent
                                pageName={props.pageName}
                                isBroadcastersOwnPage={props.isBroadcastersOwnPage}
                                editGallery={props.editGallery}
                                deleteGallery={props.deleteGallery}

                                editVideo={props.editVideo}
                                deleteVideo={props.deleteVideo}

                                openBroadcasterProfile={(content) => {
                                    const encryptBroadcasterId = getEncryptedIdForBroadcaster(content.broadcaster.id)
                                    props.history.push(`/profile/${encryptBroadcasterId}`);
                                }}
                                openDetail={(content,extra) => {
                                    if (content.type === "live" || content.type === "available") {
                                        props.history.push(`/broadcast/${getEncryptedIdForBroadcaster(content && content.id)}`)
                                    } else if (content.type === "video") {
                                       props.openVideoPage(content);
                                    } else if (content.type === "gallery") {
                                        props.openGalleryPage(content,extra);
                                    }else if (content.type === "picture") {
                                        props.openPicturePage(content,extra);
                                    }
                                }}
                                content={content}
                                key={`home-card-component-${index}`}
                                clickedOnLike={props.clickedOnLike}
                            />
                        )
                    })
                }
            </InfiniteScroll>
        </Col>
    );
}

export default HomeListContainer;